import { authApiCall } from "../../../auth";

export const getPointsBalances = () => {
  return authApiCall({
    url: `/points/balances/`,
    method: 'get',
  });
};
